/**
 * Return whether a number is even.
 *
 * @param value - The number to test.
 *
 * @returns Whether the number is even.
 */
export function isEven(value: number) {
  return value % 2 === 0;
}
